module.exports = "/static/assets/b63266e50eebc5ce414d484d2f7cc70c.png";